import uuid from 'uuid/v1';

export default function createNewFile(fileData, newFileName) {
  const uniqFileName = `${uuid()}_${newFileName}`;
  const blob = fileData.slice(0, fileData.size, fileData.type);
  const newFile = new File([blob], uniqFileName, { type: fileData.type });
  return newFile;
}
